module.exports = __webpack_public_path__ + "img/tinkoff.07eb38a7.svg";